import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    Button,
    Container
} from "reactstrap";
import rest from "../../API/api";

const PublicWaivers = () => {
    const [waivers, setWaivers] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        loadWaivers();
    }, []);

    const loadWaivers = async () => {
        try {
            const response = await fetch(rest.waiversubmitAvailable, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': rest.apiKey
                }
            });

            if (response.ok) {
                const data = await response.json();
                setWaivers(data);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error loading waivers:', error);
            setLoading(false);
        }
    };

    const handleSelectWaiver = (waiverId) => {
        history.push(`/admin/submitwaiver/${waiverId}`);
    };

    if (loading) {
        return (
            <div className="content">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Card>
                                <CardBody>
                                    <p className="text-center">Loading available waivers...</p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div className="content">
            <Container>
                <Row className="justify-content-center mb-4">
                    <Col md={10} className="text-center">
                        <h2 className="title">Available Waivers</h2>
                        <p className="description">
                            Please select a waiver to review and complete
                        </p>
                    </Col>
                </Row>

                {waivers.length === 0 ? (
                    <Row className="justify-content-center">
                        <Col md={8}>
                            <Card>
                                <CardBody className="text-center">
                                    <h4>No waivers available at this time</h4>
                                    <p>Please check back later or contact us for more information.</p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <Row className="justify-content-center">
                        {waivers.map((waiver) => {
                            return (
                                <Col md={6} lg={4} key={waiver._id} className="mb-4">
                                    <Card>
                                        <CardHeader className="text-center">
                                            <CardTitle tag="h3">{waiver.Title}</CardTitle>
                                        </CardHeader>
                                        <CardBody>
                                            {waiver.Description && (
                                                <p className="card-description text-center">
                                                    {waiver.Description}
                                                </p>
                                            )}

                                            {waiver.Version && (
                                                <p className="text-muted text-center mb-3">
                                                    <small>Version: {waiver.Version}</small>
                                                </p>
                                            )}

                                            <Button
                                                color="info"
                                                block
                                                onClick={() => handleSelectWaiver(waiver._id)}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-notes" /> Review & Sign
                                            </Button>

                                            {waiver.ImageUrl && (
                                                <div className="mt-3" style={{
                                                    padding: '15px',
                                                    backgroundColor: 'white',
                                                    border: '1px solid #e3e3e3',
                                                    borderRadius: '4px',
                                                    textAlign: 'center'
                                                }}>
                                                    <img
                                                        src={waiver.ImageUrl}
                                                        alt={waiver.Title}
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '150px',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </CardBody>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </Container>
        </div>
    );
};

export default PublicWaivers;
